import React from 'react'
import TxtVolver from '@/components/Featured/Mundial62/Logo/TxtVolver'
import { Link } from 'gatsby'
import styled from 'styled-components'

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
  .link {
    max-width: 300px;
    svg {
      width: 100%;
    }
  }
`

const PostFooter = () => {
  return (
    <Wrap>
      <Link to="/" className="link">
        <TxtVolver mainColor="#2a0b0e" accentColor="#f45115" />
      </Link>
    </Wrap>
  )
}

export default PostFooter
